// extracted by css-extract-rspack-plugin
export default {"header":"ProgramHeader_header__ZJjPG","heading":"ProgramHeader_heading__IY61E"};